/**
 * Application Configuration Constants
 * Centralized configuration for the entire application
 */

// Validate required environment variables (dev-only; avoid leaking config in production)
const validateEnvVars = () => {
  if (process.env.NODE_ENV !== 'development') return;
  const required = ['REACT_APP_API_BASE_URL', 'REACT_APP_TENANT_ID'];
  const missing = required.filter(key => !process.env[key]);
  if (missing.length > 0) {
    console.warn(`⚠️ Missing env: ${missing.join(', ')}. Using defaults. Set .env from .env.example.`);
  }
};
validateEnvVars();

// Tenant and API: use env in production; fallbacks for local dev only. Do not commit secrets.
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || '9f7da3f5-7231-4e16-9781-be825f540e99';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api-roi-v2.hostly-eg.com/api';
/** Implicit current REST contract. Breaking paths use `/vN` via endpoints helpers. */
export const DEFAULT_API_VERSION = Number(process.env.REACT_APP_API_VERSION || 1);

/**
 * Socket.IO origin (same host as the API, without the /api path).
 * Backend mounts Socket.IO on the HTTP server root (/socket.io), not under /api.
 *
 * Do NOT use String.replace('/api', '') — that corrupts hosts like api-roi-*.com
 * because "/api" appears inside "://api-...".
 */
export const getSocketBaseURL = () => {
  const explicit = process.env.REACT_APP_SOCKET_URL;
  if (explicit) {
    return explicit.replace(/\/$/, '');
  }

  try {
    return new URL(API_BASE_URL).origin;
  } catch {
    return API_BASE_URL.replace(/\/api\/?$/, '') || 'https://api-roi-v2.hostly-eg.com';
  }
};

// Export computed socket base URL
export const SOCKET_BASE_URL = getSocketBaseURL();

// Landing API Base URL (for landing page endpoints)
export const LANDING_API_BASE_URL = process.env.REACT_APP_LANDING_API_BASE_URL || 'https://api-roi-v2.hostly-eg.com';

// Backend origin (desktop control / direct socket calls). Prefer SOCKET when unset.
export const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL || SOCKET_BASE_URL;

// Auth Configuration
export const AUTH_CONFIG = {
  TOKEN_STORAGE_KEY: 'token',
  USER_STORAGE_KEY: 'user',
  DEVICE_ID_STORAGE_KEY: 'deviceId',
  EMPLOYEE_ID_STORAGE_KEY: 'employeeID',
  TENANT_ID_STORAGE_KEY: 'tenantId',
  REFRESH_TOKEN_STORAGE_KEY: 'refreshToken',
};

// Application Settings
export const APP_CONFIG = {
  TENANT_ID,
  API_BASE_URL,
  DEFAULT_API_VERSION,
  SOCKET_BASE_URL,
  LANDING_API_BASE_URL,
  BACKEND_BASE_URL,
  TIMEOUT: 30000,
  MAX_RETRIES: 3,
  AUTH_CONFIG,
};

// Role Configuration
export const ROLE_CONFIG = {
  admin: { route: '/' },
  employee: { route: '/dashboard' },
};

export default APP_CONFIG;

